import React from 'react';
import { Card, Typography, Alert, Button } from 'antd';
import { ArrowLeftOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';

const { Title, Paragraph } = Typography;

export default function AntibodyDevelopabilityPage() {
  const navigate = useNavigate();
  
  return (
    <div style={{ maxWidth: 1200, margin: '0 auto', padding: '24px' }}>
      <div style={{ marginBottom: 24 }}>
        <Button 
          icon={<ArrowLeftOutlined />} 
          onClick={() => navigate('/antibody')}
          style={{ marginBottom: 16 }}
        >
          返回抗体分析
        </Button>
        
        <Typography>
          <Title level={2}>抗体可开发性预测</Title>
          <Paragraph>
            抗体可开发性预测功能正在开发中，敬请期待！
          </Paragraph>
        </Typography>
      </div>

      <Card>
        <Paragraph>本功能正在开发中，敬请期待！</Paragraph>
          <Alert
            message="开发中"
            description="抗体可开发性预测功能即将上线，敬请关注。"
            type="info"
            showIcon
            style={{ marginTop: 24 }}
          />
        </Card>
    </div>
  );
}